
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import Accordion from "@/components/UI/Accordion.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import defensiveCopy from "@/util/defensive-copy";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import InlineRepeater from "@/components/Reusable/CustomInputs/InlineRepeater.vue";
import { propertyPathRule } from "@/lib/elements/utils";

@Component({
  components: {
    InlineRepeater,
    Repeater,
    DropdownInput,
    CodeInput,
    Dropdown,
    Accordion,
    draggable
  }
})
export default class ElementStudioPropertyPaths extends Vue {
  @Prop({ default: () => [] })
  value!: string[];

  @Prop({ default: () => [] })
  allPaths!: string[];

  updateElementValue(newValue: (string | {})[]) {
    const newValueWithNewEntryChangedToEmptyString = newValue.map(value => {
      if (typeof value === "string") {
        return value;
      }

      return "";
    });

    this.$emit("input", newValueWithNewEntryChangedToEmptyString);
  }

  updatePropertyPathByIndex(index: number, newPath: string | undefined) {
    const newValue = defensiveCopy(this.value);

    if (!newPath || !this.pathRules(newPath)) {
      return;
    }

    newValue[index] = newPath.trim();
    this.updateElementValue(newValue);
  }

  pathRules(newPath: string) {
    return propertyPathRule(newPath);
  }
}
